import React from "react"
import { Layout } from "@sudy/sui-react"
// import AccountAction from "../accountActivation"
// import LeftNav from "./left"
import {
    Form,
    Input,
    Button,
    Radio,
    Select,
    Cascader,
    DatePicker,
    InputNumber,
    TreeSelect,
    Switch,
    Card,
} from "antd"
import './style.css';
import MyIcon from './myIcon'
const { Header, Footer, Sider, Content } = Layout
const { Option } = Select

const UserCenter = () => {

    return (
        <>
            <div className="ids-container">
                <div>个人信息</div>
                <Card title="基本">
                    <div>
                        <Form
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 14 }}
                            layout="horizontal"
                            initialValues={{}}
                            onValuesChange={{}}
                            labelAlign="left"
                            // size={componentSize as SizeType}
                        >
                            <Form.Item label="头像">
                                <div>
                                    <image
                                        style={{ width: 80, height: 80 }}
                                        src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Falcdn.img.xiaoka.tv%2F20161019%2F7e9%2F304%2F34561699%2F7e930479e72e9d3c31e8cdebfa4668e3.jpg%401e_1c_0o_0l_640h_640w_90q_1pr.jpg&refer=http%3A%2F%2Falcdn.img.xiaoka.tv&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1628737053&t=75dfa0ee067f5c2954c5090d561f7e7e"
                                    ></image>
                                </div>
                            </Form.Item>

                            <Form.Item label="姓名">
                                <Input disabled />
                            </Form.Item>

                            <Form.Item label="性别">
                                <Input disabled />
                            </Form.Item>
                            <Form.Item label="出生日期">
                                <Input disabled />
                            </Form.Item>
                            <Form.Item label="职称">
                                <Input disabled />
                            </Form.Item>
                            <Form.Item label="身份证号">
                                <Input disabled />
                            </Form.Item>
                            <Form.Item label="部门/学院">
                                <Input disabled />
                            </Form.Item>
                        </Form>
                    </div>
                </Card>
                <Card
                    // title="账号设置"
                    style={{
                        marginTop: 15,
                        marginBottom: 15,
                        borderRadius: 10,
                    }}
                    headStyle={{
                        color: "#C73753",
                        paddingBottom: 0,
                        paddingTop: 0,
                    }}
                >
                    <div>
                        <div>
                            <MyIcon></MyIcon>
                            账号设置</div>
                        <Form
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 14 }}
                            layout="horizontal"
                            initialValues={{}}
                            onValuesChange={{}}
                            labelAlign="left"
                            // size={componentSize as SizeType}
                        >
                            <Form.Item label="账号">
                                <Input disabled />
                            </Form.Item>

                            <Form.Item label="手机">
                                <Input disabled />
                            </Form.Item>
                            <Form.Item label="EDU邮箱">
                                <Input disabled />
                            </Form.Item>
                        </Form>
                    </div>
                </Card>
                <Card title="密码设置">
                    <div>
                        <Form
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 14 }}
                            layout="horizontal"
                            initialValues={{}}
                            onValuesChange={{}}
                            labelAlign="left"
                            // size={componentSize as SizeType}
                        >
                            <Form.Item label="统一身份认证密码修改">
                                <Input disabled />
                            </Form.Item>
                        </Form>
                    </div>
                </Card>
            </div>
        </>
    )
}
export default UserCenter
